import {
    Box,
    Button,
    Flex,
    HStack,
    IconButton,
    Image,
    Link,
    LinkOverlay,
    Stack,
    Switch,
    Text,
    useColorMode,
    useColorModeValue,
    useDisclosure,
} from "@chakra-ui/react";
import {CloseIcon, HamburgerIcon, MoonIcon, SunIcon} from "@chakra-ui/icons";

import {LogoImageUrl} from "./imagesLink";

export default function Header() {
    const {isOpen, onOpen, onClose} = useDisclosure();
    const {colorMode, toggleColorMode} = useColorMode();

    return (
        <>
            <Box bg={useColorModeValue("gray.100", "gray.900")} px={4} position={"sticky"} top={"0%"} zIndex={"99"}>
                <Flex h={16} alignItems={"center"} justifyContent={"space-between"} width={"100%"}>
                    <IconButton
                        size={"md"}
                        icon={isOpen ? <CloseIcon/> : <HamburgerIcon/>}
                        aria-label={"Open Menu"}
                        display={{md: "none"}}
                        onClick={isOpen ? onClose : onOpen}
                    />
                    {/* Desktop navbar */}
                    <HStack spacing={8} justifyContent={["center", "center", "space-between"]} flexBasis={"content"}
                            width={"100%"} alignItems={"center"}>
                        <Box>
                            <Link href="/"><Image src={LogoImageUrl} width={"170px"} objectFit={"contain"}
                                                  alt="wpcalendar"></Image></Link>
                        </Box>
                        <HStack
                            as={"nav"}
                            spacing={4}
                            display={{base: "none", md: "flex"}}
                        >
                            <Button as={LinkOverlay} px={6} href={"/tool"} colorScheme="blue">
                                    Tool
                            </Button>
                            <Button as={LinkOverlay} px={6} href={"/help"} colorScheme="blue">
                                    Help
                            </Button>
                            <Button as={LinkOverlay} px={6} href={"/report"} colorScheme="blue">
                                    Report
                            </Button>
                        </HStack>
                    </HStack>
                    <HStack justifySelf={"flex-end"} ml={3}>
                        <Text fontSize={"sm"}> <SunIcon/> </Text>
                        <Switch colorScheme="blue" isChecked={colorMode === 'dark' ? true : false} onChange={toggleColorMode}/>
                        <Text fontSize={"sm"}> <MoonIcon/> </Text>
                    </HStack>
                </Flex>

                {isOpen ? (
                    <Box pb={4} display={{md: "none"}}>
                        <Stack as={"nav"} spacing={4}>
                            <Button as={LinkOverlay} href={"/tool"} colorScheme="blue">
                                    Tool
                            </Button>
                            <Button as={LinkOverlay} href={"/help"} colorScheme="blue">
                                    Help
                            </Button>
                            <Button as={LinkOverlay} href={"/report"} colorScheme="blue">
                                    Report
                            </Button>
                        </Stack>
                    </Box>
                ) : null}
            </Box>
        </>
    );
}
